export default __webpack_public_path__ + "static/media/a_mmun.30c3283f.svg";